import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactListItem from '@contact/components/List/ContactListItem.vue'

@Component({
    components: { ContactListItem },
})
export default class ContactList extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: P R O P : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    @Prop({ type: Array }) contactList!: contacts.ContactItem[]
}